// extracted by mini-css-extract-plugin
module.exports = {"row":"DetailItem_row__2ih1o","value":"DetailItem_value__O_EN6"};